import { createAction, props } from '@ngrx/store';

export const loadGoogleAPIKey = createAction(
  '[StaticData] Load GoogleAPIKey'
);

export const loadGoogleAPIKeySuccess = createAction(
  '[StaticData] Load GoogleAPIKey Success',
  props<{ encryptedData: string }>()
);

export const loadGoogleAPIKeyFailure = createAction(
  '[StaticData] Load GoogleAPIKey Failure',
  props<{ error: any }>()
);

